import type { LocaleEnum } from '@loyalty/utils/models';
import type { PartnerStatus } from '@models/loyalty-libs';
import type { PartnerRevision } from '@models/partner-revision';

import { createAction, props } from '@ngrx/store';

const PARTNER_REVISION_ACTIONS = {
  LOAD_PARTNER: '[PartnerRevision] Load',
  LOAD_PARTNER_SUCCESS: '[PartnerRevision] Load success',
  LOAD_PARTNER_FAILED: '[PartnerRevision] Load failed',
  UPDATE_PARTNER_REVISION_SUCCESS: '[PartnerRevision] Update success',
  SET_PARTNER_STATUS: '[PartnerRevision] Set status',
  UPDATE_PARTNER_LOCALE: '[PartnerRevision] Update Locale',
  UPDATE_PARTNER_LOCALE_SUCCESS: '[PartnerRevision] Update Locale success',
  UPDATE_PARTNER_LOCALE_FAILED: '[PartnerRevision] Update Locale failed',
} as const;

export const loadPartner = createAction(PARTNER_REVISION_ACTIONS.LOAD_PARTNER, props<{ partnerId: string }>());

export const loadPartnerSuccess = createAction(
  PARTNER_REVISION_ACTIONS.LOAD_PARTNER_SUCCESS,
  props<{ partnerRevision: PartnerRevision }>()
);

export const loadPartnerFailed = createAction(PARTNER_REVISION_ACTIONS.LOAD_PARTNER_FAILED);

export const updatePartnerRevision = createAction(PARTNER_REVISION_ACTIONS.UPDATE_PARTNER_REVISION_SUCCESS);

export const setPartnerStatus = createAction(
  PARTNER_REVISION_ACTIONS.SET_PARTNER_STATUS,
  props<{ status: PartnerStatus }>()
);

export const updatePartnerLocale = createAction(
  PARTNER_REVISION_ACTIONS.UPDATE_PARTNER_LOCALE,
  props<{ locale: LocaleEnum; partnerId: string }>()
);
export const updatePartnerLocaleSuccess = createAction(
  PARTNER_REVISION_ACTIONS.UPDATE_PARTNER_LOCALE_SUCCESS,
  props<{ locale: LocaleEnum }>()
);

export const updatePartnerLocaleFailed = createAction(PARTNER_REVISION_ACTIONS.UPDATE_PARTNER_LOCALE_FAILED);
